import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { searchEvidences } from '@src/api'
import { DefaultApiSearchEvidencesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchSearchEvidences = (
  params: DefaultApiSearchEvidencesRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => searchEvidences(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.SEARCH_EVIDENCES, params],
    placeholderData: keepPreviousData,
  })
}
